import * as React from 'react';
import { Text } from '@grandvisionhq/elements';

const HeaderTextButton = ({ label , isDisabled , onClick  })=>/*#__PURE__*/ React.createElement("button", {
        className: "modal-secondary__header-button",
        onClick: onClick,
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(Text, null, label))
;

export { HeaderTextButton };
//# sourceMappingURL=HeaderTextButton.js.map
